import React from 'react';

import {Group} from '@pb/kit-component-group';

import {HEADERS} from '../../constants';

type Props = {
    columnId: string,
};

export const DefaultHeader = ({columnId}: Props) => (
    <Group alignItems="center">
        <strong>{HEADERS[columnId]}</strong>
    </Group>
);
